import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  variantType: {
    id: 'components.surveys.components.itemTypes.genomicsReport.variantType',
    defaultMessage: 'Variant Type',
  },
  targetGene: {
    id: 'components.surveys.components.itemTypes.genomicsReport.targetGene',
    defaultMessage: 'Target Gene',
  },
  aaChange: {
    id: 'components.surveys.components.itemTypes.genomicsReport.aaChange',
    defaultMessage: 'AA Change',
  },
  ncChange: {
    id: 'components.surveys.components.itemTypes.genomicsReport.ncChange',
    defaultMessage: 'NC Change',
  },
  details: {
    id: 'components.surveys.components.itemTypes.genomicsReport.details',
    defaultMessage: 'Variant Details',
  },
  effect: {
    id: 'components.surveys.components.itemTypes.genomicsReport.effect',
    defaultMessage: 'Effect',
  },
  copyNumberValue: {
    id: 'components.surveys.components.itemTypes.genomicsReport.copyNumberValue',
    defaultMessage: 'Copy Number',
  },
  expression: {
    id: 'components.surveys.components.itemTypes.genomicsReport.expression',
    defaultMessage: 'Expression',
  },
  recommendations: {
    id: 'components.surveys.components.itemTypes.genomicsReport.recommendations',
    defaultMessage: 'Recommendations',
  },
  missingPatientContext: {
    id: 'components.surveys.components.itemTypes.genomicsReport.missingPatientContext',
    defaultMessage: 'This survey is only available via MTB Notes module',
  },
  multipleDraftReports: {
    id: 'components.surveys.components.itemTypes.genomicsReport.multipleDraftReports',
    defaultMessage:
      'There are multiple registered reports. This is not expected, please contact Support',
  },
  emptySelection: {
    id: 'components.surveys.components.itemTypes.genomicsReport.emptySelection',
    defaultMessage:
      'For increased speed and accuracy, it is recommended to only add genomic variants to the report using the {link} if sequencing data is available.',
  },
  addRecommendation: {
    id: 'components.surveys.components.itemTypes.genomicsReport.addRecommendation',
    defaultMessage: 'Add recommendation',
  },
  save: {
    id: 'components.surveys.components.itemTypes.genomicsReport.dialog.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'components.surveys.components.itemTypes.genomicsReport.dialog.cancel',
    defaultMessage: 'Cancel',
  },
  fusion: {
    id: 'components.surveys.components.itemTypes.genomicsReport.fusion',
    defaultMessage: 'Fusion',
  },
  rearrangement: {
    id: 'components.surveys.components.itemTypes.genomicsReport.rearrangement',
    defaultMessage: 'Rearrangement',
  },
  truncation: {
    id: 'components.surveys.components.itemTypes.genomicsReport.truncation',
    defaultMessage: 'Truncation',
  },
  deletion: {
    id: 'components.surveys.components.itemTypes.genomicsReport.deletion',
    defaultMessage: 'Deletion',
  },
  duplication: {
    id: 'components.surveys.components.itemTypes.genomicsReport.duplication',
    defaultMessage: 'Duplication',
  },
  alleleFrequency: {
    id: 'components.surveys.components.itemTypes.genomicsReport.alleleFrequency',
    defaultMessage: 'Allele Frequency',
  },
  copyNumberType: {
    id: 'components.surveys.components.itemTypes.genomicsReport.copyNumberType',
    defaultMessage: 'Type',
  },
  referencedResourceNotFound: {
    id: 'components.surveys.components.itemTypes.genomicsReport.referencedResourceNotFound',
    defaultMessage:
      'The genomics report saved in this draft could not be loaded (it may have been deleted or is inaccessible). Start a new note or contact support if this keeps happening.',
  },
  referencedReportWrongPatient: {
    id: 'components.surveys.components.itemTypes.genomicsReport.referencedReportWrongPatient',
    defaultMessage:
      'The saved genomics report belongs to a different patient. This draft cannot be used for the current chart.',
  },
  referencedLinkedResourcesNotFound: {
    id: 'components.surveys.components.itemTypes.genomicsReport.referencedLinkedResourcesNotFound',
    defaultMessage:
      'This genomics report references observations or tasks that could not be loaded. They may have been removed. Refresh the page; if the problem continues, contact support.',
  },
  addNewFinding: {
    id: 'components.surveys.components.itemTypes.genomicsReport.addNewFinding',
    defaultMessage: 'Add New Finding',
  },
  addNewFindingLabel: {
    id: 'components.surveys.components.itemTypes.genomicsReport.addNewFindingLabel',
    defaultMessage: 'Enter a new finding',
  },
  editFinding: {
    id: 'components.surveys.components.itemTypes.genomicsReport.editFinding',
    defaultMessage: 'Edit Finding',
  },
  omicsExplorer: {
    id: 'components.surveys.components.itemTypes.genomicsReport.omicsExplorer',
    defaultMessage: 'Omics Explorer',
  },
  removeVariant: {
    id: 'components.surveys.components.itemTypes.genomicsReport.removeVariant',
    defaultMessage: 'Remove variant',
  },
  notes: {
    id: 'components.surveys.components.itemTypes.genomicsReport.notes',
    defaultMessage: 'Notes',
  },
  addRecommendationAndNotes: {
    id: 'components.surveys.components.itemTypes.genomicsReport.addRecommendationAndNotes',
    defaultMessage: 'Add recommendation and notes',
  },
  trialId: {
    id: 'components.surveys.components.itemTypes.genomicsReport.trialId',
    defaultMessage: 'Trial ID',
  },
  unknown: {
    id: 'components.surveys.components.itemTypes.genomicsReport.unknown',
    defaultMessage: 'Unknown',
  },
});

export const isMessageLabel = (label: string): label is keyof typeof messages =>
  !!(messages as any)[label];
